<template>
  <v-card>
    <v-card-title>
      <span class="text-h6"> {{ deliveryAddress.name }} </span>

      <v-spacer></v-spacer>

      <v-btn color="success" outlined class="mr-2" @click="saveAll" small>
        {{ $t("Xác nhận") }}
      </v-btn>
      <v-btn color="error" outlined @click="closeDialog" small>
        {{ $t("Đóng") }}
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-simple-table fixed-header class="table-padding-2">
        <template v-slot:default>
          <thead class="v-data-table-header">
            <tr>
              <th role="columnheader" class="text-center">Cơ sở</th>
              <th role="columnheader" class="text-center" style="width: 110px">
                Khoảng cách (m)
              </th>
              <th role="columnheader" class="text-center" style="width: 75px">
                Ưu tiên
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in branches"
              :key="`d_${index}`"
              class="text-center"
            >
              <td>{{ item.code }}</td>
              <td>
                <input-number
                  v-model.number="item.distance"
                  type="number"
                  outlined
                  dense
                  hide-details
                  class="c-input-small"
                />
              </td>
              <td>
                <v-icon color="primary" v-if="priorityId == item.id">
                  mdi-radiobox-marked
                </v-icon>
                <v-icon
                  color="primary"
                  v-else
                  class="cursor-pointer"
                  @click="selectPriority(item)"
                >
                  mdi-radiobox-blank
                </v-icon>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { httpClient } from "@/libs/http";

export default {
  name: "DialogDirection",

  props: {
    account: {
      type: Object,
      default: () => {},
    },
    deliveryAddress: {
      type: Object,
      default: () => {},
    },
  },

  data: () => ({
    branches: [],
    isLoading: false,
    priorityId: 0,
  }),

  created() {},

  mounted() {
    this.getList();
  },

  methods: {
    closeDialog() {
      this.$emit("close");
    },
    refreshData() {
      this.$emit("refreshData");
    },
    selectPriority(item) {
      this.priorityId = item.id;
    },
    getList() {
      httpClient
        .post("/me/v1/get-account-direction", {
          id_account: this.account.id,
          id_account_delivery_address: this.deliveryAddress.id,
        })
        .then(({ data }) => {
          const branches = window.me.branches.filter(
            (br) => br.id_city == this.deliveryAddress.id_city
          );

          for (let i = 0; i < branches.length; i++) {
            const branch = branches[i];
            const item = [...data].find((d) => d.id_branch == branch.id);
            if (item) {
              branch.distance = item.distance;
              branch.duration = item.duration;
              if (item.is_priority) {
                this.priorityId = branch.id;
              }
            } else {
              const distance = this.calDistanceByLatLng({
                sLat: branch.latitude,
                sLng: branch.longitude,
                eLat: this.deliveryAddress.latitude,
                eLng: this.deliveryAddress.longitude,
              });
              branch.distance = Math.floor(distance * 1.25);
              branch.duration = 0;
            }

            branches[i] = { ...branch };
          }

          if (!this.priorityId) {
            this.priorityId = branches[0].id;
          }

          this.branches = [...branches];
        });
    },
    async saveAll() {
      const items = [];
      for (let i = 0; i < this.branches.length; i++) {
        const item = this.branches[i];
        item.distance = item.distance || 0;
        item.duration = Math.round(item.distance / 12);
        let is_priority = 0;
        if (this.priorityId == item.id) {
          is_priority = 1;
        }

        items.push({
          id_branch: item.id,
          distance: item.distance,
          duration: item.duration,
          is_priority,
        });
      }

      if (this.isLoading) {
        this.$vToastify.warning(this.$t("messages.loading"));
        return false;
      }
      this.isLoading = true;

      try {
        await httpClient.post("/me/v1/save-account-direction", {
          id_account: this.account.id,
          id_account_delivery_address: this.deliveryAddress.id,
          items,
        });
        this.isLoading = false;
        this.$vToastify.success("Cập nhật thành công");
        this.refreshData();
        this.closeDialog();
      } catch (e) {
        const errMsg =
          (e.response &&
            e.response.data &&
            e.response.data.error &&
            e.response.data.error.message) ||
          null;
        this.$vToastify.error(errMsg);
        this.isLoading = false;
      }
    },
  },
};
</script>
